<template>
  <div id="photos" class="page">
    <section class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ol class="breadcrumb">
              <li>
                <router-link to="/">Accueil</router-link>
              </li>
              <li>Photos de réalisations</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="faq-pg-section section-padding-50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="section-title-s4">
              <h1>Photos de réalisations <div>Garde-corps inox</div></h1>
              <blockquote>Cliquez sur les vignettes ci-dessous pour découvrir l'aspect des produits OXYNOV, garde-corps inox pour terrasse, balcon, palier, mezzanine, escalier... avec main courante bois ou main courante inox, remplissage tubes ou câbles, photos d'accessoires pour garde-corps.</blockquote>
            </div>
            <hr class="separator">
            <div id="achievements">
              <div class="row">
                <div class="col-md-12">
                  <div id="filter-button-group">
                    <button data-filter="*" @click="filterImages($event)" class="btn btn-primary btn-outlined active">Tout afficher</button>
                    <button :data-filter="'.' + k" v-for="(v, k) in achievements" class="btn btn-primary btn-outlined" v-bind:key="k" @click="filterImages($event)">{{ v.title }}</button>
                  </div>
                  <hr>
                  <div id="grid">
                    <div :id="'gallery-' + k" class="element-group" v-for="(v, k) in achievements" v-bind:key="k" @click="openGallery('gallery-' + k, $event)">
                      <div class="element-item" v-for="(i, j) in v.data" v-bind:key="j" :class="k">
                        <a :href="'/static/images/realisations/' + v.folder + '/' + i.name + '.jpg'" :title="i.title">
                          <img :src="'/static/images/realisations/' + v.folder + '/' + i.name + '-min.jpg'" class="img-responsive" :alt="i.alt" height="120px">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'

export default {
  name: 'Photos',
  data () {
    return {
      iso: {},
      achievements: {
        'main_courrante_inox': {
          title: 'Main courante inox',
          folder: 'mci',
          data: [
            { name: 'coin-garde-corps-inox-tubes', alt: 'Coin d\'une balustrade inox', title: 'Coin d\'une balustrade inox' },
            { name: 'coude-articule-inox-main-courante', alt: 'Coude articulé inox pour rampe', title: 'coude articulé pour une rampe inox' },
            { name: 'garde-corps-inox', alt: 'garde corps inox sur une terrasse', title: 'garde-corps inox sur une terrasse balcon' },
            { name: 'garde-corps-inox-balcon', alt: 'garde corps balcon', title: 'garde corps pour balcon' },
            { name: 'garde-corps-inox-balcon2', alt: 'balustrade inox pour balcon', title: 'Balustrade pour balcon en inox' },
            { name: 'garde-corps-inox-cables-pose-laterale', alt: 'pose latérale de cable inox', title: 'pose de cables inox sur balustrade inox' },
            { name: 'garde-corps-inox-contour-terrasse', alt: 'gardecorps pour les contours d\'une terrasse', title: 'garde corps pour terrasse' },
            { name: 'garde-corps-inox-fenetre', alt: 'garde-corps pour fenêtre', title: 'Garde-corps inox pour fenêtre' },
            { name: 'garde-corps-inox-panneaux-verre', alt: 'Panneaux de verre pour garde corps inox', title: 'installation de panneaux de verre pour gardecorps' },
            { name: 'garde-corps-inox-piscine', alt: 'garde corps inox spéciale piscine', title: 'un garde corps pour votre piscine' },
            { name: 'garde-corps-inox-remplissage-cable-piscine1', alt: 'garde-corps inox autour d\'une piscine', title: 'Garde-corps inox autour d\'une piscine' },
            { name: 'garde-corps-inox-remplissage-cable-piscine2', alt: 'balustrade pour piscine', title: 'garde-corps de sécurité pour votre piscine' },
            { name: 'garde-corps-inox-remplissage-cable-piscine3', alt: 'rambarde inox pour piscine', title: 'rambarde inox pour piscine' },
            { name: 'garde-corps-inox-remplissage-tubes', alt: 'balustrade avec un remplissade tube en inox', title: 'Balustrade avec un remplissade de tubes inox' },
            { name: 'garde-corps-inox-terrasse', alt: 'garde-corps pour terrasse composite', title: 'Garde-corps terrasse' },
            { name: 'garde-corps-inox-terrasse-escalier', alt: 'rampe d\'escalier inox', title: 'rampe inox pour escalier terrasse' },
            { name: 'garde-corps-inox-tubes', alt: 'tubes inox pour garde-corps', title: 'tubes inox pour garde corps' },
            { name: 'garde-corps-inox-tubes-panneau-verre', alt: 'panneau de verre et tubes pour balustrade inox', title: 'panneau de verre et tubes inox pour balustrades' },
            { name: 'garde-corps-terrasse-inox', alt: 'garde corps pour terrasse', title: 'Garde-corps inoxpour terrasse extérieure' },
            { name: 'main-courante-inox-raccords-articules', alt: 'raccords articulés pour garde corps inox', title: 'Raccords articulés pour balustrades inox' },
            { name: 'poteaux-inox-garde-corps', alt: 'poteaux inox pour rambarde', title: 'Poteaux rambarde en inox' },
            { name: 'rambarde-inox', alt: 'rambarde inox', title: 'rambarde inox' },
            { name: 'rambarde-terrasse-inox', alt: 'rambarde pour terrasse inox', title: 'rambarde pour terrasse inox' },
            { name: 'rampant-inox-tubes', alt: 'rampant inox et tubes inox', title: 'rampant inox pour terrasse' },
            { name: 'rampe-escalier-rambarde-inox', alt: 'rampe d\'escalier inox', title: 'rampe d\'escalier inox' },
            { name: 'rampe-escaliers-inox-panneau-verre', alt: 'panneaux de verre pour escalier inox', title: 'panneaux de verre pour escalier' },
            { name: 'remplissage-tubes-garde-corps-2', alt: 'remplissade de tubes inox pour garde-corps', title: 'remplissage de garde-corps inox' }
          ]
        },
        'main_courrante_bois': {
          title: 'Main courante bois',
          folder: 'mcb',
          data: [
            { name: 'garde-corps-inox-bois-panneaux-verre', alt: 'main courante en bois pour garde-corps inox', title: 'Main courante en bois pour balustrade' },
            { name: 'garde-corps-inox-bois-terrasse-escalier', alt: 'garde-corps inox pour terrasse pilotis', title: 'Garde corps inox installé sur une terrasse pilotis' },
            { name: 'garde-corps-inox-main-courante-bois', alt: 'main courante en bois pour balustrade de sécurité', title: 'Main courante en bois' },
            { name: 'garde-corps-main-courante-bois', alt: 'vue de haut d\'une rampe bois sur balustrade inox', title: 'main courante en bois vue de haut' },
            { name: 'garde-corps-main-courante-bois-tubes1', alt: 'remplissade d\'une main courante bois de tubes inox', title: 'main courante bois et tubes inox' },
            { name: 'garde-corps-main-courante-bois-tubes2', alt: 'main courante en bois sur garde corps inox et tubes', title: 'tubes inox et main courante bois' },
            { name: 'garde-corps-main-courante-bois-tubes3', alt: 'balcon avec main courante bois', title: 'terrasse sur balcon avec main courante en bois' },
            { name: 'garde-corps-main-courante-bois-tubes4', alt: 'terrasse sur les toits avec garde-corps inox', title: 'main courante en bois sur terrasse toit' },
            { name: 'garde-corps-main-courante-bois-tubes5', alt: 'balustrade inox avec main courante bois', title: 'main courante bois et balustrade inox' },
            { name: 'garde-corps-main-courante-bois-tubes6', alt: 'rambarde inox et rampe bois', title: 'rampe en bois et rambarde inox' },
            { name: 'rampant-bois-tubes', alt: 'rampe bois et garde-corps inox pour escalier extérieur', title: 'descente d\'escalier avec rampe bois' }
          ]
        },
        'remplissage_tube': {
          title: 'Remplissage tubes',
          folder: 'rt',
          data: [
            { name: 'boules-d-ornement-tube-garde-corps', alt: 'boules d\'ornements pour garde-corps inox', title: 'ornements inox pour balustrades' },
            { name: 'coin-garde-corps-inox-tubes', alt: 'coin de garde corps inox', title: 'coin de rambarde inox' },
            { name: 'fixation-panneau-acrylique-transparent-2', alt: 'panneaux acrylique pour balustrade inox', title: 'panneaux acrylique pour garde corps' },
            { name: 'fixation-tubes-remplissage-inox', alt: 'tubes inox de remplissage', title: 'garde corps avec tubes inox de remplissage' },
            { name: 'garde-corps-inox', alt: 'garde corps en inox', title: 'garde-corps inox' },
            { name: 'garde-corps-inox-balcon', alt: 'garde corps pour balcon', title: 'garde corps de sécurité pour balcon' },
            { name: 'garde-corps-inox-balcon2', alt: 'balustrade balcon en inox', title: 'balustrade en inox' },
            { name: 'garde-corps-inox-bois-panneaux-verre', alt: 'panneaux de verre pour rambarde inox', title: 'panneaux de verre pour garde-corps' },
            { name: 'garde-corps-inox-bois-terrasse-escalier', alt: 'garde-corps pour escalier d\'extérieur', title: 'escalier d\'extérieur avec rampe' },
            { name: 'garde-corps-inox-contour-terrasse', alt: 'garde-corps inox qui entoure une terrasse', title: 'terrasse entourée d\'une balustrade' },
            { name: 'garde-corps-inox-fenetre', alt: 'garde-corps inox pour fenêtre', title: 'balustrade pour fenêtre' },
            { name: 'garde-corps-inox-main-courante-bois', alt: 'main courante en bois', title: 'rampe en bois' },
            { name: 'garde-corps-inox-panneaux-verre', alt: 'panneaux de verre pour balustrade inox', title: 'balustrade avec des panneaux de verre' },
            { name: 'garde-corps-inox-piscine', alt: 'piscine avec balustrade en inox', title: 'piscine avec balustrade de sécurité' },
            { name: 'garde-corps-inox-remplissage-tubes', alt: 'tubes inox pour balustrade', title: 'tubes inox dans un garde-corps' },
            { name: 'garde-corps-inox-terrasse', alt: 'garde-corps pour terrasse', title: 'garde corps inox pour terrasse bois' },
            { name: 'garde-corps-inox-terrasse-escalier', alt: 'escalier extérieur avec rampe inox', title: 'escalier extérieur avec rampe' },
            { name: 'garde-corps-inox-tubes', alt: 'tubes inox pour gardecorps', title: 'remplissage tubes inox' },
            { name: 'garde-corps-inox-tubes-panneau-verre', alt: 'tubes inox et panneaux de verre', title: 'balustrade avec panneaux de verre et tubes inox' },
            { name: 'garde-corps-main-courante-bois', alt: 'main courante en bois', title: 'main courante en bois' },
            { name: 'garde-corps-main-courante-bois-tubes1', alt: 'tubes inox pour rambarde', title: 'main courante et remplissage tubes' },
            { name: 'garde-corps-main-courante-bois-tubes2', alt: 'tubes inox pour balustrade', title: 'garde-corps avec tubes inox' },
            { name: 'garde-corps-main-courante-bois-tubes3', alt: 'tubes inox pour garde-corps inox', title: 'balustrade inox et tubes' },
            { name: 'garde-corps-main-courante-bois-tubes4', alt: 'Balustrade et remplissage tubes inox', title: 'main courante en bois et tubes en inox' },
            { name: 'garde-corps-main-courante-bois-tubes5', alt: 'Garde-corps et remplissage tubes inox', title: 'balustrade en inox avec une rampe en bois' },
            { name: 'garde-corps-main-courante-bois-tubes6', alt: 'Rambarde et remplissage tubes inox', title: 'rambarde bois et tubes inox' },
            { name: 'garde-corps-terrasse-inox', alt: 'garde corps pour terrasse en bois', title: 'garde corps inox pour terrasse bois' },
            { name: 'main-courante-inox-raccords-articules', alt: 'raccord pour main courante inox', title: 'raccords articulés pour garde corps inox' },
            { name: 'plaque-acrylique-transparente-pour-garde-corps', alt: 'plaque acrylique transparente pour garde corps inox', title: 'plaque acrylique pour balustrades inox' },
            { name: 'platines-murales-fixations-tubes', alt: 'fixation murale inox', title: 'fixation pour rambarde inox' },
            { name: 'rambarde-inox', alt: 'rambarde inox', title: 'rambarde inox' },
            { name: 'rambarde-terrasse-inox', alt: 'rambarde pour terrasse', title: 'rambarde inox pour terrasse' },
            { name: 'rampant-bois-tubes', alt: 'rampe en bois et remplissage tubes inox', title: 'rampe d\'escalier extérieur' },
            { name: 'rampant-inox-tubes', alt: 'rampe en inox pour escalier extérieur', title: 'rampe inox d\'escalier extérieur' },
            { name: 'rampe-escalier-rambarde-inox', alt: 'escalier avec une rampe en inox', title: 'rampe en inox pour escalier' },
            { name: 'rampe-escaliers-inox-panneau-verre', alt: 'panneau de verre pour rambarde inox', title: 'panneaux de verre pour garde-corps inox' },
            { name: 'remplissage-tubes-garde-corps-2', alt: 'remplissage tubes dans garde-corps inox', title: 'tubes inox dans un garde-corps' }
          ]
        },
        'remplissage_cables': {
          title: 'Remplissage câbles',
          folder: 'rc',
          data: [
            { name: 'garde-corps-inox-cables-pose-laterale', alt: 'cables inox sur un garde corps pour balcon', title: 'Garde corps sur un balcon' },
            { name: 'garde-corps-inox-remplissage-cable-piscine1', alt: 'balustrade avec des cables inox', title: 'Garde-corps inox pour piscine' },
            { name: 'garde-corps-inox-remplissage-cable-piscine2', alt: 'rambarde inox avec des cables', title: 'Garde-corps inox pour piscine avec des cables inox' },
            { name: 'garde-corps-inox-remplissage-cable-piscine3', alt: 'garde-corps avec des cables inox', title: 'Garde-corps inox pour piscine - remplissage cables' }
          ]
        },
        'accessoires': {
          title: 'Accessoires',
          folder: 'a',
          data: [
            { name: 'boules-d-ornement-tube-garde-corps', alt: 'boules d\'ornements inox pour balustrade', title: 'finition de tubes inox' },
            { name: 'coude-articule-inox-main-courante', alt: 'coude inox articulé pour garde-corps', title: 'coude articulé pour garde corps inox' },
            { name: 'fixation-panneau-acrylique-transparent-2', alt: 'panneaux acrylique pour balustrade inox', title: 'Panneaux acrylique pour garde-corps piscine' },
            { name: 'plaque-acrylique-transparente-pour-garde-corps', alt: 'plaque acrylique pour rambarde inox', title: 'plaque acrylitque pour garde-corps' },
            { name: 'platines-murales-fixations-tubes', alt: 'platine murale pour fixation garde-corps inox', title: 'fixation de votre garde-corps avec platine inox' }
          ]
        }
      }
    }
  },
  methods: {
    initGallery () {
      this.iso = new Isotope('#grid', {
        itemSelector: '.element-item',
        layoutMode: 'masonry'
      })
    },
    filterImages (e) {
      document.getElementById('filter-button-group').querySelector('.active').classList.remove('active')
      this.iso.arrange({ filter: e.target.getAttribute('data-filter') })
      e.target.classList.add('active')
    },
    openGallery (id, event) {
      /* eslint-disable */
      event = event || window.event;
      var target = event.target || event.srcElement,
        link = target.src ? target.parentNode : target,
        options = {index: link, event: event},
        links = document.getElementById(id).getElementsByTagName('a');
      blueimp.Gallery(links, options);
      event.preventDefault()
    }
  },
  mounted () {
    let vm = this
    imagesLoaded( document.querySelector('#grid'), function( instance ) {
      vm.initGallery()
    })
  }
}
</script>

<style type="text/css" scoped>
#achievements .element-item {
  width: 25%;
  float:left;
  padding: 1px;
}
#filter-button-group .btn {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Photos.vue